<template>
	<div>
		<vs-popup class="holamundo" :title="$t('SerialNumber')" :active.sync="isSerialNumberPopup"
			@close="closeSerialNumberPopup" @cancel="closeSerialNumberPopup" fullscreen>
			<b-tabs content-class="mt-3" v-model="serialTabs">
				<b-tab :title="$t('General')" active>
					<vs-card>
						<b-row>
							<b-col lg="4" sm="12">
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('Serial')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="7">
										<vs-input size="small" v-model="Serial" type="text" class="w-full" name="Serial"
											v-validate="'required'" />
										<span class="text-danger text-sm" v-show="errors.has('Serial')">{{
											errors.first("Serial")
										}}</span>
									</b-col>
									<b-col cols="1" class="ml-0" style="padding-left: 0px; margin-left: 0px !important">
										<b-button variant="outline-light" style="padding: 0px" v-on:click="updateSerialNo()">
											<Icon icon="pajamas:task-done" width="20" height="20" class="text-success"
												v-b-tooltip.hover.bottom="$t('SerialManagement')" />
										</b-button>

									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('Title')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="Title" type="text" class="w-full" name="Title"
											v-validate="'required'" />
										<span class="text-danger text-sm" v-show="errors.has('Title')">{{
											errors.first("Title")
										}}</span>
									</b-col>
								</b-row>

								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('PurchasePrice')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="PurchasePrice" type="text" class="w-full" name="PurchasePrice" />
									</b-col>
								</b-row>

								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('Supplier')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="Supplier" :options="supplier_choices" size="small" label="name"
											autocomplete ref="selectElement" name="productGroup">
										</v-select>
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center"> </b-col>
									<b-col cols="8" style="text-align: end">
										<b-button style="border-color: white" v-on:click="submitSerialNumber()" class="bg-primary mt-15">
											{{ $t("Save") }}
										</b-button>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="8" sm="12">
								<b-row style="margin-top: 8px">
									<b-col lg="2" sm="8"></b-col>
									<b-col lg="10" sm="8">
										<b-form-group :label="'* ' + $t('Description')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
										<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new-serialNumber-desc"
											:settings="settings" :key="$vs.rtl">
											<quill-editor v-model="Description" style="height: 300px"></quill-editor>
										</component>
										<prism class="rounded-lg"> {{ Description }} </prism>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</vs-card>
				</b-tab>
				<b-tab :title="$t('Price')">
					<vs-card>
						<b-row>
							<b-col lg="4" sm="12">
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('SellerPrice')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="SellerPrice" type="text" class="w-full" name="SellerPrice" />
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('SellerCurrentCode')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="SellerCurrentCode" type="text" class="w-full"
											name="SellerCurrentCode" />
									</b-col>
								</b-row>

								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('CurrentPrice')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="CurrentPrice" type="text" class="w-full" name="CurrentPrice" />
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('CurrentPriceCode')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="CurrentPriceCode" type="text" class="w-full"
											name="CurrentPriceCode" />
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('LocalCurrentPrice')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="LocalCurrentPrice" type="text" class="w-full"
											name="LocalCurrentPrice" />
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('LocalCurrentCode')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="LocalCurrentCode" type="text" class="w-full"
											name="LocalCurrentCode" />
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center"> </b-col>
									<b-col cols="8" style="text-align: end">
										<b-button style="border-color: white" v-on:click="submitSerialPrice()" class="bg-primary mt-15">
											{{ $t("Save") }}
										</b-button>
									</b-col>
								</b-row>
							</b-col>
						</b-row>

						<b-col style="text-align: end">
							<!--      <b-button
						style="border-color: white; width: inherit"
						v-on:click="generateSerialNumbers()"
						size="sm"
						:disabled="dataForSerial.length > 0"
					>
						{{ $t("Generate") }}
					</b-button>-->
						</b-col>
					</vs-card>
				</b-tab>
				<b-tab :title="$t('BanayeniProperties')"
					@click="marketplace_choices.length <= 0 ? getCustomerMarketplaces() : ''; listStockSerialProperties()">
					<vs-card>
						<b-row class="mb-2">
							<b-col cols="5">
								<b-row>
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('Marketplace') + ': '" class="vs-input--label pr-0 mr-0"
											label-for="h-first-name">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select v-model="marketplace" label="Name" :options="marketplace_choices" size="small"
											autocomplete ref="selectElement" @input="banayeniTagList">
											<template slot="option" slot-scope="option">
												<b-row>
													<b-col cols="2">
														<img v-if="mpControl(option.Name)" :src="require('../../assets/images/logo/' + option.Name.trim() + '.png')
															" width="30" v-b-tooltip.hover.bottom="option.Name" @error="errorImage" />
													</b-col>
													<b-col>
														{{ option.Prefix }} -
														{{ option.Name }}
													</b-col>
												</b-row>
											</template>
										</v-select>
									</b-col>
								</b-row>
							</b-col>

						</b-row>
						<b-row>
							<b-col lg="5" sm="12">
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('usageStatusId')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="usageStatusId" :options="usage_choices" size="small" label="name"
											autocomplete ref="selectElement" name="usageStatusId">
										</v-select>

									</b-col>
								</b-row>

								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('subUsageStatusId')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="subUsageStatusId" :options="subusage_choices" size="small"
											label="name" autocomplete ref="selectElement" name="subUsageStatusId">
										</v-select>
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('workingconditionid')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="workingconditionid" :options="workingcondition_choices"
											size="small" label="name" autocomplete ref="selectElement" name="workingconditionid">
										</v-select>
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('originalPackageStatusId')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="originalPackageStatusId" :options="originalPackage_choices"
											size="small" label="name" autocomplete ref="selectElement" name="originalPackageStatusId">
										</v-select>
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('warrantyStatusId')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="warrantyStatusId" :options="warranty_choices" size="small"
											label="name" autocomplete ref="selectElement" name="warrantyStatusId">
										</v-select>
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('invoiceStatusId')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="invoiceStatusId" :options="invoicestatus_choices" size="small"
											label="name" autocomplete ref="selectElement" name="invoiceStatusId">
										</v-select>


									</b-col>
								</b-row>


								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('tagIds')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="tagIds" :options="tags_choices"
											style="border-top-right-radius: 0; border-bottom-right-radius: 0" label="description" autocomplete
											ref="selectElement" v-validate="'required'" name="name" multiple>
										</v-select>
									</b-col>
								</b-row>
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('cargoSendDayOptionId')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="cargoSendDayOptionId" :options="cargosend_choices" size="small"
											label="name" autocomplete ref="selectElement" name="cargoSendDayOptionId">
										</v-select>
									</b-col>
								</b-row>

								<!--
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('isFirstOwner')" label-for="h-first-name" style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="isFirstOwner" :options="status_choices" size="small" label="name"
											autocomplete ref="selectElement" name="isFirstOwner">
										</v-select>
									</b-col>
								</b-row>
							-->



								<!--
								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('usageDurationMonth')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="usageDurationMonth" :options="usageDurationM_choices" size="small"
											label="name" autocomplete ref="selectElement" name="usageDurationMonth">
										</v-select>
									</b-col>
								</b-row>

								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('usageDurationYear')" label-for="h-first-name"
											style="font-weight: 600">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="usageDurationYear" :options="usageDurationY_choices" size="small"
											label="name" autocomplete ref="selectElement" name="usageDurationYear">
										</v-select>
									</b-col>
								</b-row>
							-->

								<b-row style="margin-top: 8px">
									<b-col cols="4" align-self="center"> </b-col>
									<b-col cols="8" style="text-align: end">
										<b-button style="border-color: white" v-on:click="submitSerialBanayeniProperties()"
											:disabled="marketplace == ''" class="vs-con-loading__container bg-primary mt-15"
											id="loading-save-list">
											{{ $t("Save") }}
										</b-button>
									</b-col>
								</b-row>
							</b-col>
						</b-row>

						<b-col style="text-align: end">
							<!--      <b-button
						style="border-color: white; width: inherit"
						v-on:click="generateSerialNumbers()"
						size="sm"
						:disabled="dataForSerial.length > 0"
					>
						{{ $t("Generate") }}
					</b-button>-->
						</b-col>
					</vs-card>
				</b-tab>
				<b-tab :title="$t('Picture')">
					<vs-card>
						<b-row>
							<b-col lg="5">
								<b-row align-v="center">
									<vs-card>
										<b-row class="mb-8 mt-8">
											<UploadImageDynamic :isUploaded="isUploaded" :uploadMethod="'setImageFSerial'" />
										</b-row>
										<b-row class="justify-content-md-end">
											<b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
												<b-button class="bg-danger" style="border-color: white" v-on:click="clearFields()">
													<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20"
														height="20" />{{
															$t("Cancel") }}
												</b-button>
											</b-col>

											<b-col cols="12" md="auto" style="padding: 0px">
												<b-button style="border-color: white" v-on:click="imageSave()"
													class="vs-con-loading__container bg-primary" id="loading-stockList">
													{{ $t("SaveImage") }}
												</b-button></b-col>
										</b-row>
									</vs-card>
								</b-row>
							</b-col>
							<b-col>
								<vs-card>
									<div v-if="previewUrl">
										<b-row>
											<b-col v-for="(url, index) in previewUrl" :key="index" lg="3" sm="6">
												<b-button v-on:click="clearLocalImage(index)" size="sm" variant="outline-light">
													<Icon icon="material-symbols:close" width="25" height="25"
														v-b-tooltip.hover.bottom="$t('Delete')" color="#ea5455" />
												</b-button>
												<img :src="url.StockSerialImageFilePath" style="width: 100%" />
											</b-col>
										</b-row>
										<b-row>
											<b-col v-for="(url, index) in addedImage" :key="index" lg="3" sm="6">
												<b-button v-on:click="removeSerialImage(url)" size="sm" variant="outline-light">
													<Icon icon="material-symbols:close" width="25" height="25"
														v-b-tooltip.hover.bottom="$t('Delete')" color="#ea5455" />
												</b-button>
												<img :src="`${imageUrl + url.StockSerialImageFilePath}?t=${new Date().getTime()}`"
													style="width: 100%" :alt="'Image ' + index" />

											</b-col>
										</b-row>
									</div>
								</vs-card>
							</b-col>
						</b-row>
					</vs-card>
				</b-tab>
			</b-tabs>
		</vs-popup>
		<div class="demo-inline-spacing">
			<b-form ref="form" @submit.prevent="repeateAgain">
				<b-row>
					<b-col cols="12"> </b-col>
					<b-col cols="12"> </b-col>

					<b-col cols="12">
						<b-row>
							<b-col cols="5">
								<h6 style="text-align: center">{{ $t("SerialNumber") }}</h6>
							</b-col>
							<b-col cols="5">
								<h6 style="text-align: center">{{ $t("Supplier") }}</h6>
							</b-col>

							<b-col cols="1"> </b-col>
						</b-row>
					</b-col>

					<b-col cols="12">
						<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new-serialNumber-add"
							:settings="settings" :key="$vs.rtl">
							<b-row v-for="(item, index) in items" :id="item.stockSerialId" :key="item.id" ref="row"
								style="padding-right: 25px">
								<!-- Item Name -->
								<b-col cols="5" style="padding-right: 0">
									<b-form-group label-for="cost">
										<b-form-input v-model="item.code" style="font-size: inherit" id="cost" type="text"
											@keyup.enter="addSerialNumber(index)" :placeholder="$t('SerialNumber')"
											:disabled="item.disabled" />
									</b-form-group>
								</b-col>
								<b-col cols="5" style="padding-right: 0">
									<b-form-group label-for="cost">
										<v-select color="danger" v-model="item.supplier" :options="supplier_choices" size="small"
											label="name" autocomplete ref="selectElement" name="productGroup">
										</v-select>
									</b-form-group>
								</b-col>
								<!-- Quantity -->

								<b-col v-if="!isMobile()" style="padding-right: 0" cols="2" class="mb-50">
									<b-row v-if="item.stockSerialId == ''">
										<b-col style="padding: 0">
											<b-button variant="outline-light" size="sm" v-on:click="addSerialNumber(index)">
												<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
											</b-button>
										</b-col>
									</b-row>
									<b-row v-else>
										<b-col style="padding: 0; max-width: max-content">
											<b-button variant="outline-light" size="sm" v-on:click="
												isSidebarActiveProcess = true;
											deleteSerialNumberInd = index;
											">
												<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="20" height="20" />
											</b-button>
										</b-col>
										<b-col style="padding: 0; max-width: max-content">
											<b-button variant="outline-light" size="sm"
												v-on:click="updateSerialNumber(index); serialIndex = index">
												<Icon color="#7367F0" icon="material-symbols:select-check-box" width="20" height="20" />
											</b-button>
										</b-col>
									</b-row>
								</b-col>
								<b-col v-else style="padding-right: 0; padding-left: 0" cols="2" class="mb-50">
									<b-row v-if="item.stockSerialId == ''">
										<b-col style="padding: 0">
											<b-button variant="outline-light" size="sm" v-on:click="addSerialNumber(index)">
												<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
											</b-button>
										</b-col>
									</b-row>
									<b-row v-else>
										<b-col style="padding: 0; max-width: max-content">
											<b-button variant="outline-light" size="sm" v-on:click="
												isSidebarActiveProcess = true;
											deleteSerialNumberInd = index;
											">
												<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
											</b-button>
										</b-col>
										<b-col style="padding: 0; max-width: max-content">
											<b-button variant="outline-light" size="sm" v-on:click="updateSerialNumber(index)">
												<Icon color="#7367F0" icon="material-symbols:select-check-box" width="18" height="20" />
											</b-button>
										</b-col>
									</b-row>
								</b-col>
								<!-- Remove Button -->
								<b-col cols="12" style="height: 5px"> </b-col> </b-row>
						</component>
					</b-col>
				</b-row>

				<!-- Row Loop -->
			</b-form>
		</div>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')" @accept="deleteSerialNumber"
			:active.sync="isSidebarActiveProcess" color="danger">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t("DoConfirm") }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
	</div>
</template>
<script>
import { uuid } from "vue-uuid";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import UploadImageDynamic from "../components/global-components/UploadImageDynamic.vue";
import { quillEditor } from "vue-quill-editor";
import Prism from "vue-prism-component";
import userJson from "../../../public/user.json";
import { Validator } from "vee-validate";
export default {
	props: ["data"],
	data() {
		return {
			workingconditionid: "",
			banayeniAddProductPropId: "",
			invoicestatus_choices: [{ name: "Duruyor, gönderilecek", value: 1 }, { name: "Alıcı adına kesilecek", value: 2 }, { name: "Yok", value: 3 }],
			status_choices: [{ name: "Aktif", value: 1 }, { name: "Pasif", value: 2 }],
			check_choices: [{ name: "Evet", value: 1 }, { name: "Hayır", value: 2 }],
			warranty_choices: [{ name: "Garantili", value: 1 }, { name: "Garantisiz", value: 2 }],
			cargosend_choices: [{ name: "1-2 gün içinde", value: 2 }, { name: "3-4 gün içinde", value: 3 }, { name: "1 Hafta içinde", value: 4 }, { name: "1 haftadan uzun", value: 5 }],
			usageDurationM_choices: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			usageDurationY_choices: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
			usage_choices: [{ name: "İkinci El", value: 500200 }, { name: "Sıfır", value: 100100 }, { name: "Outlet", value: 100300 }, { name: "Teşhir", value: 100400 }],
			subusage_choices: [{ name: "Kullanılmamış", value: 10 }, { name: "Az kullanılmış", value: 20 }, { name: "Kullanılmış", value: 30 }],
			originalPackage_choices: [{ name: "Orjinal Kutusunda", value: 1 }, { name: "Orjinal Kutusu Hasarlı", value: 3 }, { name: "Orjinal Kutusu Yok", value: 2 }],
			workingcondition_choices: [{ name: "Çalışıyor", value: 10 }, { name: "Kısmen çalışıyor", value: 20 }, { name: "Parça niyetine", value: 30 }],
			tags_choices: [],
			marketplace_choices: [],
			marketplace: "",
			"tagIds": "",
			"processId": "",
			"invoiceStatusId": 0,
			"isFirstOwner": false,
			"warrantyStatusId": 0,
			"originalPackageStatusId": 0,
			"cargoSendDayOptionId": 0,
			"usageDurationMonth": 0,
			"usageDurationYear": 0,
			"usageStatusId": 0,
			"subUsageStatusId": 0,
			serialIndex: null,
			imageUrl: userJson.imageUrl,
			addedImage: [],
			selectedFile: [],
			previewUrl: [],
			isUploaded: false,
			serialTabs: "",
			Serial: "",
			SerialNumber: "",
			Title: "",
			Description: "",
			StockTransCode: "",
			StockTransPriceInfoId: "",
			PurchasePrice: "",
			SellerPrice: 0,
			SellerCurrentCode: "",
			CurrentPrice: 0,
			CurrentPriceCode: "",
			LocalCurrentPrice: 0,
			LocalCurrentCode: "",
			StockTransId: "",
			Supplier: "",
			StockSerialId: "",
			serialNumberAllData: [],
			dataForSerial: [],
			isSerialNumberPopup: false,
			supplier_choices: [],
			deleteSerialNumberInd: null,
			isSidebarActiveProcess: false,
			isMobile: function () {
				return isMobile;
			},
			searchedValue: "",
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			items: [
				{
					id: 0,
					supplier: "",
					code: "",
					disabled: false,
					stockSerialId: "",
					stockId: "",
				},
			],
		};
	},
	components: {
		UploadImageDynamic,
		quillEditor,
		Prism,
		vSelect,
		Icon,
		VuePerfectScrollbar,
	},
	watch: {
		tags(val) {
			this.getTagsList();
			return val
		},
		supplier(val) {
			this.getSupplierList();

			return val;
		},
		data() {
			this.getStockSerialNumbersList(this.data.StockId);
			this.getSupplierList();
		},
	},
	methods: {
		findInTagList(id) {
			const tag = this.tags_choices.find(tag => tag.id == id);
			return tag ? tag.description : id;
		},
		listStockSerialProperties() {
			const vs = this.$vs;
			this.timelineData = [];
			this.$store
				.dispatch("stock/listStockSerialProperties", this.StockSerialId)
				.then((response) => {
					// let costumerList = JSON.parse(response.json);
					if (response.success == true) {
						let listSerial = JSON.parse(response.json)
						let tagSplit = listSerial.tagIds.split(",")
						let tagL = []
						tagSplit.forEach((val, index) => {
							tagL.push({ description: this.findInTagList(val), id: val })
						});
						//this.marketplace_choices = JSON.parse(response.json);
						//[{ name: "Exist", value: 1 }, { name: "WillCreateForBuyer", value: 2 }, { name: "NonExist", value: 3 }],
						//[{ name: "Evet", value: 1 }, { name: "Hayır", value: 0 }],

						//subusage_choices: [{ name: "Kullanılmamış", value: 10 }, { name: "Az kullanılmış", value: 20 }, { name: "Kullanılmış", value: 30 }],
						//cargosend_choices: [{ name: "1-2 gün içinde", value: 2 }, { name: "3-4 gün içinde", value: 3 }, { name: "1 Hafta içinde", value: 4 }, { name: "1 haftadan uzun", value: 5 }],
						//usage_choices: [{ name: "İkinci El", value: 500200 }],
						//originalPackage_choices: [{ name: "Orjinal Kutusunda", value: 1 }, { name: "Orjinal Kutusu Hasarlı", value: 3 }, { name: "Orjinal Kutusu Yok", value: 2 }],
						//warranty_choices: [{ name: "Garantili", value: 1 }, { name: "Garantisiz", value: 2 }],
						//workingcondition_choices: [{ name: "Çalışıyor", value: 10 }, { name: "Kısmen çalışıyor", value: 20 }, { name: "Parça niyetine", value: 30 }],
						//usage_choices: [{ name: "İkinci El", value: 500200 }, { name: "Sıfır", value: 100100 }, { name: "Outlet", value: 100300 }, { name: "Teşhir", value: 100400 }],

						this.banayeniAddProductPropId = listSerial.banayeniAddProductPropId
						this.cargoSendDayOptionId = { name: listSerial.cargoSendDayOptionId == 2 ? "1-2 gün içinde" : listSerial.cargoSendDayOptionId == 3 ? "3-4 gün içinde" : listSerial.cargoSendDayOptionId == 4 ? "1 Hafta içinde" : "1 haftadan uzun", value: listSerial.cargoSendDayOptionId }
						this.invoiceStatusId = { name: listSerial.invoiceStatusId == 1 ? "Var" : listSerial.invoiceStatusId == 2 ? "Alıcı için oluşturulacak" : "Yok", value: listSerial.invoiceStatusId }
						this.isFirstOwner = { name: listSerial.isFirstOwner == 1 ? "Aktif" : "Pasif", value: listSerial.isFirstOwner }
						this.originalPackageStatusId = { name: listSerial.originalPackageStatusId == 1 ? "Orjinal Kutusunda" : listSerial.originalPackageStatusId == 2 ? "Orjinal Kutusu Yok" : "Orjinal Kutusu Hasarlı", value: listSerial.originalPackageStatusId }
						this.serial = listSerial.serial
						this.serialId = listSerial.serialId
						this.subUsageStatusId = { name: listSerial.subUsageStatusId == 10 ? "Kullanılmamış" : listSerial.subUsageStatusId == 20 ? "Az kullanılmış" : "Kullanılmış", value: listSerial.subUsageStatusId }
						this.tagIds = tagL
						this.usageDurationMonth = listSerial.usageDurationMonth
						this.usageDurationYear = listSerial.usageDurationYear
						this.usageStatusId = {
							name: listSerial.usageStatusId == 500200 ? "İkinci El" :
								listSerial.usageStatusId == 100100 ? "Sıfır" : listSerial.usageStatusId == 100300 ? "Outlet" : "Teşhir", value: listSerial.usageStatusId
						}
						this.warrantyStatusId = { name: listSerial.warrantyStatusId == 1 ? "Garantili" : "Garantisiz", value: listSerial.warrantyStatusId }
						this.workingconditionid = { name: listSerial.workingconditionid == 10 ? "Çalışıyor" : listSerial.workingconditionid == 20 ? "Kısmen çalışıyor" : "Parça niyetine", value: listSerial.workingconditionid }
					} else {
						this.banayeniAddProductPropId = "";
						this.cargoSendDayOptionId = { name: "1-2 gün içinde", value: 2 }
						this.invoiceStatusId = { name: "Var", value: 1 }
						this.isFirstOwner = { name: "Aktif", value: 1 }
						this.originalPackageStatusId = { name: "Orjinal Kutusunda", value: 1 }
						this.subUsageStatusId = { name: "Kullanılmamış", value: 10 }
						this.tagIds = ""
						this.usageDurationMonth = 1
						this.usageDurationYear = 1
						this.usageStatusId = { name: "İkinci El", value: 500200 }
						this.warrantyStatusId = { name: "Garantili", value: 1 }
						this.workingconditionid = { name: "Çalışıyor", value: 10 }
						console.log(response.statusText);
					}
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
		},
		submitSerialBanayeniProperties() {
			const vs = this.$vs;
			let type = "material";
			vs.loading({
				container: `#loading-save-list`,
				type,
				scale: 0.75,
			});
			let obj = {
				"banayeniAddProductPropId": uuid.v4(),
				"tagIds": this.tagIds
					? this.tagIds.map((item) => item.id).join(',')
					: '',
				"invoiceStatusId": typeof this.invoiceStatusId === 'object' &&
					this.invoiceStatusId !== null
					? this.invoiceStatusId.value
					: this.invoiceStatusId || 0,
				"isFirstOwner": false,
				"workingconditionid": typeof this.workingconditionid === 'object' &&
					this.workingconditionid !== null
					? this.workingconditionid.value
					: this.workingconditionid || 0,
				/*	typeof this.isFirstOwner === 'object' && this.isFirstOwner !== null ? this.isFirstOwner.value : this.isFirstOwner || 0,*/
				"warrantyStatusId": typeof this.warrantyStatusId === 'object' &&
					this.warrantyStatusId !== null
					? this.warrantyStatusId.value
					: this.warrantyStatusId || 0,
				"originalPackageStatusId": typeof this.originalPackageStatusId === 'object' &&
					this.originalPackageStatusId !== null
					? this.originalPackageStatusId.value
					: this.originalPackageStatusId || 0,
				"cargoSendDayOptionId": typeof this.cargoSendDayOptionId === 'object' &&
					this.cargoSendDayOptionId !== null
					? this.cargoSendDayOptionId.value
					: this.cargoSendDayOptionId || 0,
				"usageDurationMonth": this.usageDurationMonth == 0 ? 0 : this.usageDurationMonth,
				"usageDurationYear": this.usageDurationYear == 0 ? 0 : this.usageDurationYear,
				"usageStatusId": typeof this.usageStatusId === 'object' &&
					this.usageStatusId !== null
					? this.usageStatusId.value
					: this.usageStatusId || 0,
				"subUsageStatusId": typeof this.subUsageStatusId === 'object' &&
					this.subUsageStatusId !== null
					? this.subUsageStatusId.value
					: this.subUsageStatusId || 0,
				"serialId": this.StockSerialId,
				"serial": this.dataForSerial.Serial
			}
			let propMethod = ""
			if (this.banayeniAddProductPropId != "") {
				propMethod = "updateStockSerialProperties"
				obj["banayeniAddProductPropId"] = this.banayeniAddProductPropId
			} else {
				propMethod = "addStockSerialProperties"
			}
			console.log(JSON.stringify(obj))
			this.$store
				.dispatch("stock/" + propMethod, obj)
				.then((response) => {
					if (response.status == 200) {
						setTimeout(() => {
							vs.loading.close("#loading-save-list> .con-vs-loading");
						}, 1000);
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});

						this.listStockSerialProperties();

					} else {
						setTimeout(() => {
							vs.loading.close("#loading-save-list> .con-vs-loading");
						}, 1000);
						vs.notify({
							text: response.data[0].value.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					setTimeout(() => {
						vs.loading.close("#loading-save-list> .con-vs-loading");
					}, 1000);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		mpControl(e) {
			if (
				!e.includes("Toplu") &&
				!e.includes("Flip") &&
				!e.includes("Php") &&
				!e.includes("Tümü")
			)
				return true;
			else return false;
		},
		errorImage(e) {
			if (e.type == "error")
				e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
		},
		getCustomerMarketplaces() {
			const vs = this.$vs;
			this.timelineData = [];
			this.$store
				.dispatch("customer/listCustomerinfoForRole", this.data.CompanyId)
				.then((response) => {
					// let costumerList = JSON.parse(response.json);
					if (response.success == true) {
						this.marketplace_choices = JSON.parse(response.json);
					} else console.log(response.statusText);
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
		},
		submitSerialPrice() {
			const vs = this.$vs;
			let obj = {
				stockTransPriceId: this.StockTransPriceInfoId,
				localCurrentCode: this.LocalCurrentCode,
				localCurrentPrice: this.LocalCurrentPrice,
				currentPriceCode: this.CurrentPriceCode,
				currentPrice: this.CurrentPrice,
				sellerCurrentCode: this.SellerCurrentCode,
				sellerPrice: this.SellerPrice,
				stockTransId: this.StockTransId,
				stockTransCode: this.StockTransCode,
				serial: this.Serial
			};
			this.$store
				.dispatch("stock/updateStockTransPrice", obj)
				.then((response) => {
					if (response.status == 200) {
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
						this.editStockTrans();
						this.isSstocktransEditPopup = false;
					} else {
						vs.notify({
							text: response.data[0].value.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		formatPath(path) {
			return path.replace(/^.*?(SerialImage\/)/, "$1");
		},
		convertToWebPath(path) {
			return path.replace(/\\/g, "/");
		},
		clearLocalImage(index) {
			this.selectedFile.splice(index, 1);
			this.previewUrl.splice(index, 1);
		},
		getSupplierList() {
			this.supplierListOption = [];
			this.supplier_choices = [];
			this.supplierListOption = this.supplier;
			this.supplierListOption.forEach((val, index) => {
				this.supplier_choices.push({
					value: val.SupplierId,
					name: val.SupplierName,
				});
			});
		},
		getTagsList() {
			this.tagsListOption = [];
			this.tags_choices = [];
			this.tagsListOption = this.tags;
			this.tagsListOption.forEach((val, index) => {
				this.tags_choices.push({
					value: val.SupplierId,
					name: val.SupplierName,
				});
			});
		},
		getStockSerialNumbersListForData() {
			this.getStockSerialNumbersList(this.data.StockId);
		},
		deleteSerialNumberFunc(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("stock/deleteStockSerialNumber", data.stockSerialId)
				.then((response) => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.getStockSerialNumbersList(this.data.StockId);
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data[0].value.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		getStockSerialNumbersList(serialNumberId) {
			this.items = [
				{
					id: 0,
					supplier: "",
					code: "",
					disabled: false,
					stockSerialId: "",
					stockId: "",
				},
			];
			const vs = this.$vs;
			if (serialNumberId)
				this.$store
					.dispatch("stock/listStockSerialNumbersForStock", serialNumberId)
					.then((response) => {
						// let costumerList = JSON.parse(response.json);
						if (response.success == true) {
							let allSerialNumbersData = this.$store.state.stock.StockSerialNumbers;
							this.serialNumberAllData = this.$store.state.stock.StockSerialNumbers;

							if (this.serialIndex) this.updateSerialNumber(this.serialIndex)
							allSerialNumbersData.forEach((val, index) => {
								this.items.push({
									id: index + 1,
									supplier: { name: val.SupplierName, value: val.SupplierId },
									code: val.Serial,
									disabled: false,
									stockSerialId: val.StockSerialId,
									stockId: val.StockId,
								});
							});
						} else
							console.log(
								response.statusText
							); /*
					vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
					});
		},
		deleteSerialNumber() {
			this.deleteSerialNumberFunc(this.items[this.deleteSerialNumberInd]);
		},
		getSerialNumberList() { },
		removeSerialImage(item) {
			const vs = this.$vs;
			this.$store
				.dispatch("stock/deleteStockSerialImage", item.StockSerialImageId)
				.then((response) => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.imageList();
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		submitSerialNumber(data) {
			const vs = this.$vs;
			this.$validator.validateAll().then((result) => {
				if (result) {
					var createdId = uuid.v4();
					const obj = {
						stockId: this.data.StockId,
						stockSerialId: this.StockSerialId != "" ? this.StockSerialId : createdId,
						title: this.Title,
						purchasePrice: this.PurchasePrice,
						description: this.Description ? this.Description : "",
						supplierId: this.Supplier.value,
						supplierName: this.Supplier.name,
						serial: this.dataForSerial.Serial,
					};
					if (this.StockSerialId != "") {
						this.$store
							.dispatch("stock/updateStockSerialNumber", obj)
							.then((response) => {
								if (response.status == 200) {
									vs.notify({
										text: response.data.message,
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "success",
										position: "top-center",
									});
									this.$root.$emit("getStockList");
									this.getStockSerialNumbersList(this.data.StockId);
									this.$root.$emit("getStockListForPalletItems");

									this.$emit("closeSidebar");
									this.initValues();
								} else {
									vs.notify({
										text: response.data.message.toString(),
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "danger",
										position: "top-center",
									});
								}
							})
							.catch((error) => {
								console.log(error)
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					} else {
						delete obj.id;
						this.$store
							.dispatch("stock/addStockSerialNumber", obj)
							.then((response) => {
								if (response.status == 200) {
									vs.notify({
										text: response.data.message,
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "success",
										position: "top-center",
									});
									this.getStockSerialNumbersList(this.data.StockId);
									this.$root.$emit("getStockListForPalletItems");

									this.initValues();
								} else {
									vs.notify({
										text: response.data.message.toString(),
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "danger",
										position: "top-center",
									});
								}
							})
							.catch((error) => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					}
				} else {
					vs.notify({
						text: this.$t("Validate"),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center",
					});
				}
			})

		},
		addSerialNumber(ind) {
			this.submitSerialNumber(this.items[ind]);
		},
		clearFields() {
			this.isUploaded = false;
			this.previewUrl = [];
			this.selectedFile = [];
		},
		setImage(data) {
			data.forEach((val, index) => {
				this.previewUrl.push({ StockSerialImageFilePath: URL.createObjectURL(val) });
				this.selectedFile.push(val);
			});
		},
		banayeniTagList() {
			this.$store
				.dispatch("stock/listBanayeniTagLists", this.marketplace.CompanyInfoId)
				.then((response) => {
					if (response.success == true) {
						try {
							this.tags_choices = JSON.parse(response.json)
							if (this.banayeniAddProductPropId != "") this.listStockSerialProperties()
						} catch (error) {
							console.log(error);
						}
					} else {
						console.log(response.data.message.toString());
					}
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		priceList() {
			this.$store
				.dispatch("stock/listStockTransPriceByTransId", this.Serial)
				.then((response) => {
					if (response.success == true) {
						try {
							let serialPrices = JSON.parse(response.json);

							this.CurrentPrice = serialPrices[0].currentPrice;
							this.CurrentPriceCode = serialPrices[0].currentPriceCode;
							this.LocalCurrentCode = serialPrices[0].localCurrentCode;
							this.LocalCurrentPrice = serialPrices[0].localCurrentPrice;
							this.SellerCurrentCode = serialPrices[0].sellerCurrentCode;
							this.SellerPrice = serialPrices[0].sellerPrice;
							this.SerialNumber = serialPrices[0].serialNumber;
							this.StockTransPriceInfoId = serialPrices[0].stockTransPriceId;
							this.StockTransId = serialPrices[0].stockTransId;
							this.StockTransCode = serialPrices[0].stockTransCode;
						} catch (error) {
							console.log(error);
						}
					} else {
						console.log(response.data.message.toString());
					}
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		imageList() {
			this.$store
				.dispatch("stock/listStockSerialImageForSerial", this.StockSerialId)
				.then((response) => {
					if (response.success == true) {
						try {
							this.addedImage = JSON.parse(response.json);
						} catch (error) {
							console.log(error);
						}
					} else {
						this.addedImage = [];
					}
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		imageSave() {
			if (!this.selectedFile) {
				alert("Lütfen bir dosya seçin!");
				return;
			}
			const vs = this.$vs;
			let formData = new FormData();
			console.log(this.selectedFile)
			this.selectedFile.forEach((val, ind) => {
				formData.append(`stockSerialImageFiles`, val);
			});
			formData.append("stockSerialId", this.StockSerialId);
			formData.append("stockSerialNo", this.Serial);
			this.$store
				.dispatch("stock/addStockSerialImage", formData)
				.then((response) => {
					try {
						if (response.success == true) {
							vs.notify({
								text: response.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.imageList();
							this.previewUrl = [];
							this.selectedFile = []
						} else {
							vs.notify({
								text: response.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					} catch (error) {
						console.log(error);
					}
				})
				.catch((error) => {
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		closeSerialNumberPopup() {
			this.isUploaded = false;
			this.previewUrl = [];
			this.selectedFile = [];
			this.dataForSerial = [];
			this.serialIndex = null
		},
		updateSerialNo() {
			const vs = this.$vs;

			let obj = {
				serial: this.dataForSerial.Serial,
				newSerial: this.Serial
			}
			this.$store
				.dispatch("stock/updateStockNewSerialNumber", obj)
				.then((response) => {
					if (response.status == 200) {
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
						this.getStockSerialNumbersList(this.data.StockId);
					} else {
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					console.log(error)
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		updateSerialNumber(ind) {
			this.dataForSerial = this.serialNumberAllData[ind - 1];
			this.Serial = this.dataForSerial.Serial;
			this.Title = this.dataForSerial.Title;
			this.Description = this.dataForSerial.Description;
			this.PurchasePrice = this.dataForSerial.PurchasePrice;
			this.StockSerialId = this.dataForSerial.StockSerialId;
			this.Supplier = this.dataForSerial.SupplierId
				? {
					name: this.dataForSerial.SupplierName,
					value: this.dataForSerial.SupplierId,
				}
				: "";
			this.isSerialNumberPopup = true;
			this.serialTabs = 0;
			this.imageList();
			this.priceList();
			//	this.banayeniTagList();
			//  this.submitSerialNumber(this.items[ind]);
		},
		clearFields() {
			this.items = [
				{
					id: 0,
					supplier: "",
					code: "",
					disabled: false,
					stockSerialId: "",
					stockId: "",
				},
			];
		},
	},

	computed: {

		tags: {
			get() {
				return this.$store.state.customer.BanayeniTagsList;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		supplier: {
			get() {
				return this.$store.state.customer.Supplier;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	mounted() {
		if (this.data.CompanyId != "") {

			this.getCustomerMarketplaces();
		}
		this.$root.$on("setImageFSerial", (data) => {
			if (data) this.isUploaded = true;
			this.setImage(data);
		});
	},
	beforeDestroy() {
		this.$root.$off("setImageFSerial");
	},
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new-serialNumber-add {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area--data-list-add-new-serialNumber-desc {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.con-vs-popup {
	z-index: 5311000;
}

.editor-container {
	width: 500px !important;
	height: 300px !important;
}
</style>
